import { useNavigate } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';

export default function LatestArticles() {
  const navigate = useNavigate();
  const latest = articles.slice(0, 8);

  const getCategoryName = (slug: string) => {
    return categories.find((c) => c.slug === slug)?.name || slug;
  };

  const handleClick = (slug: string) => {
    navigate(`/article/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">最新文章</h2>
            <p className="text-sm text-foreground-500 mt-1">持续更新的麻将竞技内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latest.map((article) => (
            <article
              key={article.slug}
              onClick={() => handleClick(article.slug)}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-5 cursor-pointer hover:border-primary-200 hover:bg-background-100 transition-all"
            >
              <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full mb-3 whitespace-nowrap">
                {getCategoryName(article.category)}
              </span>
              <h3 className="font-heading font-semibold text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-500 line-clamp-2 mb-4">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-400 pt-3 border-t border-background-200/50">
                <span>{article.author}</span>
                <span>{article.date}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-8">
          <button
            onClick={() => { navigate('/category/baojing-anli'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="px-6 py-2.5 border border-secondary-300 text-secondary-700 hover:bg-secondary-50 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
}